<template>
    <div>
        <div style="padding: 0px 16px;">
 
            <el-button type="primary" @click="exportAllFunc()" size="small" icon="el-icon-download" style="float:right; margin-left:10px;">导出所有</el-button>
            <!-- <el-button type="primary" @click="exportAllfinishedFunc()" size="small" icon="el-icon-download" style="float:right;">导出已完成工单</el-button> -->
            <!-- <el-button type="primary" @click="exportAllUnfinishedFunc()" size="small" icon="el-icon-download" style="float:right;">导出未完成工单</el-button> -->
        </div>

        <div style="padding: 10px 16px">
            <el-table
                id="unit"
                :data="orderList"
                style="width: 100%;border-color:'#606266'"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                :cell-style="{color: '#666',fontSize:'14px'}"
                border
                >

                <el-table-column
                    fixed
                    align="center"
                    prop="order_id"
                    label="工单ID"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    
                    align="center"
                    prop="order_status"
                    label="工单类型"
                    sortable
                    >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.order_status == 0">已完成</el-tag>
                        <el-tag v-else-if="scope.row.order_status == 1">进行中</el-tag>
                        <el-tag v-else-if="scope.row.order_status == 2">待使用</el-tag>
                        <el-tag v-else-if="scope.row.order_status == 3">待支付</el-tag>
                        <el-tag v-else-if="scope.row.order_status == 4">已取消</el-tag>
                        <el-tag v-else>错误的类型</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="shop_name"
                    label="店铺名称"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="room_name"
                    label="包间名称"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="phone_num"
                    label="下单人手机号"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="order_time"
                    label="下单时间"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="start_time"
                    label="开始时间"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="end_time"
                    label="结束时间"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="play_type"
                    label="玩法"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="time_type"
                    label="时间类型"
                    sortable
                    >
                </el-table-column>

                

                <el-table-column
                    align="center"
                    prop="pay_type"
                    label="支付类型"
                    sortable
                    >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.pay_type == 0">微信支付</el-tag>
                        <el-tag type="danger" v-else>余额支付</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                    align="center"
                    prop="is_renew"
                    label="是否续订"
                    sortable
                    >
                    <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.is_renew">是</el-tag>
                        <el-tag type="success" v-else>否</el-tag>
                    </template>
                </el-table-column>
                
                <el-table-column
                    align="center"
                    prop="renew_hour"
                    label="续订小时"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed="right"
                    align="center"
                    prop="order_money"
                    label="订单金额"
                    sortable
                    >
                </el-table-column>
                
            </el-table>

            <el-pagination
                @current-change="changeCurrent"
                :current-page="iCurrentPage"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="iMaxTotal"
                style="text-align:right; margin-top:15px"
                >
            </el-pagination>

        </div>
    </div>
</template>

<script>
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
export default {

name: "OrderSystem",
data() {
    return {
        iCurrentPage: 1,
        iMaxTotal: 10,
        orderList: [],
    };
},

mounted(){
    this.getOrderList()

},

methods: {
    // 获取订单列表
    async getOrderList(){
        let url = '/api/order/'
        let params = {
            'page': this.iCurrentPage,
            'page_size': 10
        }

        console.log(params)
        let res = await this.$axios.get(url, {params: params})
        this.orderList = res.data.results
        this.iMaxTotal = res.data.count
    },

    // 分页事件
    changeCurrent(val){
        this.iCurrentPage = val;
        console.log(this.iCurrentPage)
        this.getOrderList();
    },

    // 导出所有
    async exportAllFunc(){
        // 请求数据
        await this.$axios.get('/api/order/').then(
            function(res){
                console.log(res.data)
                // 将请求到数据转换为数组数据
                var data = res.data
                var arrData = typeof data != 'object' ? JSON.parse(data) : data
                var wb = XLSX.utils.book_new();
                var ws = XLSX.utils.json_to_sheet(arrData);
                XLSX.utils.book_append_sheet(wb, ws, '工单列表');
                var wbout = XLSX.write(wb, {bookType:'xlsx', type:'binary'});
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
                FileSaver.saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "订单数据.xlsx");
            }
        )
    },




},
  
  
};
</script>

<style>

</style>

